import {
  AppMinimumRequirementsForRecaptcha,
  GenericForm,
  GenericFormLogic,
  giftcardNumberFormLogic,
  giftcardPinFormLogic,
  recaptchaFormLogic,
} from "../../../Common";

export interface AccessForm extends GenericForm {
  giftcardNumber?: string;
  giftcardNumberError?: string;

  giftcardPin?: string;
  giftcardPinError?: string;

  recaptchaError?: string;
}

export const initialAccessForm = (): AccessForm => ({});

export interface AccessFormApp extends AppMinimumRequirementsForRecaptcha {}

export const AccessFormLogic: GenericFormLogic<
  Omit<
    AccessForm,
    "giftcardNumberError" | "giftcardPinError" | "recaptchaError"
  >,
  AccessFormApp
> = {
  giftcardNumber: giftcardNumberFormLogic({ required: true }),
  giftcardPin: giftcardPinFormLogic({ required: true }),
  recaptcha: recaptchaFormLogic<AccessForm, AccessFormApp>({
    initialStateKey: "giftcard_balance_recaptcha",
  }),
} as const;
